import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesCambioDeDestinatario() {
  return (
    <ClipperPlaceholder title="Cambio de Destinatario" category="Novedades" />
  );
}
